import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.connectors', {
        url: '/connectors',
        component: 'userConnectors',
        resolve: {connectors},
    })
}

/** @ngInject */
function connectors(Connector) {
    return Connector.query().$promise;
}



// WEBPACK FOOTER //
// ./src/portal/states/user/connectors/connectors.state.js